

import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

// Los datos comunes son usados en los selectores
// se envian datos de la forma
/* {
        "datoComun": "obtenerLocalidades",  <--- valor que se desea consultar
        "codigoProvincia": 1                <--- opcional para algunas consultas
} */
Vue.use(Vuex)

export default ({
    namespaced: true,

    state: {
        estadoCivil: [],
        nacionalidades: [],
        provincias: [],
        tipoCarrier: [],
        tipoDoc: ['DNI'], // item select tipo de dni
        tipoContacto: [],
        tiposFamiliares: [],
        tiposFamiliaresPre: [],
        localidades: [],
        datosDistrito: [],
        codigoPais: [],
        tipoNacionalidad: [],
        tipoContactoFiltro: [],
        tipoTelefono: [],

        itemNivel: [],
    },

    getters: {
        item(state) {
            return state.item
        },
        itemNivel(state) {
            return state.itemNivel
        },
        estadoCivil(state) {
            return state.estadoCivil
        },
        nacionalidades(state) {
            return state.nacionalidades
        },
        provincias(state) {
            return state.provincias
        },
        tipoCarrier(state) {
            return state.tipoCarrier
        },
        tipoContacto(state) {
            return state.tipoContacto
        },
        localidades(state) {
            return state.localidades
        },
        datosDistrito(state) {
            return state.datosDistrito
        },
        tiposFamiliares(state) {
            return state.tiposFamiliares
        },
        tiposFamiliaresPre(state) {
            return state.tiposFamiliaresPre
        },
        codigoPais(state) {
            return state.codigoPais
        },
        tipoNacionalidad(state) {
            return state.tipoNacionalidad
        },
        tipoContactoFiltro(state) {
            return state.tipoContactoFiltro
        },
        tipoTelefono(state) {
            return state.tipoTelefono
        },
        tipoDoc(state) {
            return state.tipoDoc
        }

    },
    mutations: {
        setEstadoCivil(state, estadoCivil) {
            state.estadoCivil = estadoCivil
        },
        setNacionalidades(state, nacionalidades) {
            state.nacionalidades = nacionalidades
        },
        setProvincias(state, provincias) {
            state.provincias = provincias
        },
        setTipoCarrier(state, tipoCarrier) {
            state.tipoCarrier = tipoCarrier
        },
        setTipoContacto(state, tipoContacto) {
            state.tipoContacto = tipoContacto
        },
        setLocalidades(state, localidades) {
            state.localidades = localidades
        },
        setTiposFamiliares(state, tiposFamiliares) {
            state.tiposFamiliares = tiposFamiliares
        },
        setTiposFamiliaresPre(state, tiposFamiliaresPre) {
            state.tiposFamiliaresPre = tiposFamiliaresPre
        },
        setCodigoPais(state, codigoPais) {
            state.codigoPais = codigoPais
        },
        setDatosDistrito(state, datosDistrito) {
            state.datosDistrito = datosDistrito
        },
        setTipoNacionalidad(state, tipoNacionalidad) {
            state.tipoNacionalidad = tipoNacionalidad
        },
        setTipoTelefono(state, tiposTelefono) {
            state.tipoTelefono = tiposTelefono
        },
        setTipoContactoFiltro(state, tipoContactoFiltro) {
            state.tipoContactoFiltro = tipoContactoFiltro
        },
        //mutations relacionado a opcion de nivel
        setItemNivel(state, payload) {
            state.itemNivel = payload
        },
    },
    actions: {
        async getTipoCarrier({ state, commit }, obj) {
            if (state.tipoCarrier.length > 0) return
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/obtenerDatosComunes',
                withCredentials: false,
                data: JSON.stringify(obj),
                headers: {
                    "Content-Type": "application/json",
                },
            })
                .then(function (response) {
                    const res = response.data.tiposCarrier
                    commit('setTipoCarrier', res)
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        async getTipoContacto({ state, commit, dispatch }, obj) {
            if (state.tipoContacto.length > 0) return
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/obtenerDatosComunes',
                withCredentials: false,
                data: JSON.stringify(obj),
                headers: {
                    "Content-Type": "application/json",
                }
            })
                .then(function (response) {
                    const res = response.data.tiposContacto
                    commit('setTipoContacto', res)
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        async getLocalidades({ commit }, obj) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/obtenerDatosComunes',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(obj)
            })
                .then(function (response) {
                    const res = response.data.localidades
                    commit('setLocalidades', res)
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        async getCodigoPais({ state, commit }, obj) {
            if (state.codigoPais.length > 0) return
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/obtenerDatosComunes',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(obj)
            })
                .then(function (response) {
                    const res = response.data.codigosPais
                    commit('setCodigoPais', res)
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        async getTiposFamiliares({ state, commit }, obj) {
            if (state.tiposFamiliares.length > 0) return
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/obtenerDatosComunes',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(obj)
            })
                .then(function (response) {
                    const res = response.data.tiposFamiliares
                    const res2 = response.data.tiposFamiliares.filter(item => (item.id == 1) || (item.id == 2) || (item.id == 6))
                    commit('setTiposFamiliares', res)
                    commit('setTiposFamiliaresPre', res2)
                })
                .catch(function (error) {
                    console.log(error)
                })
        },
        async getDatosDistrito({ commit, dispatch }, obj) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/obtenerDatosComunes',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(obj)
            })
                .then(function (response) {
                    const res = response.data.datosDistrito[0]
                    console.log(res)
                    commit('setDatosDistrito', res)
                })
                .catch(function (error) {
                    console.log(error)
                }).finally(() => {
                    dispatch('auth/setSktLoader', false, { root: true })
                })
        },
        async getProvincias({ state, commit }, obj) {
            if (state.provincias.length > 0) return
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/obtenerDatosComunes',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(obj)
            })
                .then(function (response) {
                    const res = response.data.provincias
                    commit('setProvincias', res)
                })
                .catch(function (error) {
                    console.log(error)
                })

        },
        /*         { datoComun: 'obtenerEstadoCivil', fitro: 1 -> filtrado filtro: 0 ->
                                
                } */
        async getEstadoCivil({ commit }, obj) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/obtenerDatosComunes',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(obj)
            })
                .then(function (response) {
                    const res = response.data.estadoCivil.filter(item => (item.id !== 8) && (item.id !== 10))
                    commit('setEstadoCivil', res)
                })
                .catch(function (error) {
                    console.log(error)
                })

        },
        async getNacionalidades({ state, commit }, obj) {
            if (state.nacionalidades.length > 0) return
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/obtenerDatosComunes',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(obj)
            })
                .then(function (response) {
                    const res = response.data.nacionalidades.filter(nacionalidad =>
                        nacionalidad.id == 1 || nacionalidad.id == 5
                    )
                    commit('setNacionalidades', res)
                })
                .catch(function (error) {
                    console.log(error)
                })

        },
        async getTipoNacionalidad({ state, commit }, obj) {
            if (state.tipoNacionalidad.length > 0) return
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/obtenerDatosComunes',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(obj)
            })
                .then(function (response) {
                    const res = response.data.tipoNacionalidad.filter(nacionalidad => nacionalidad.tna_id !== 3)
                    commit('setTipoNacionalidad', res)
                })
                .catch(function (error) {
                    console.log(error)
                })

        },
        async getTipoTelefono({ commit }, obj) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/obtenerDatosComunes',
                withCredentials: false,
                headers: {
                    "Content-Type": "application/json",
                },
                data: JSON.stringify(obj)
            })
                .then(function (response) {
                    const res = response.data.tiposTelefono.filter(telefono => telefono.ttel_destelefono !== 'FAX')
                    commit('setTipoTelefono', res)
                })
                .catch(function (error) {
                    console.log(error)
                })

        },
        async getItemsNivel({ commit, dispatch }) {
            //dispatch('notificaciones/startLoading', null, { root: true })
            await axios({
                method: 'get',
                url: process.env.VUE_APP_API + 'afiliacion/nivel/obtenerTablaReferencia',
                withCredentials: false
            }).then(function (response) {
                commit('setItemNivel', response.data.tablaReferenciaNivel)
            }).catch(function (error) {
                dispatch('notificaciones/showSnack', {
                    message: error.response.data.message,
                    type: (error.response.status).toString(),
                }, { root: true })
            }).finally(() => {
                dispatch('notificaciones/stopLoading', null, { root: true })
            })
        },
        getTipoContactoFiltro({ commit, getters }, aFiltrar) {
            const filtrado = getters['tipoContacto'].filter(e => !aFiltrar.includes(e.tcnt_des_tipcontacto))
            commit('setTipoContactoFiltro', filtrado)
        },
        levantarCommon({ commit, dispatch }, payload) {
            dispatch('getTipoContacto', { datoComun: 'obtenerTiposContacto' })
            dispatch('getTipoNacionalidad', { datoComun: 'obtenerTipoNacionalidad' })
            dispatch('getNacionalidades', { datoComun: 'obtenerNacionalidades' })
            dispatch('getTipoCarrier', { datoComun: 'obtenerTiposCarrier' })
            dispatch('getCodigoPais', { datoComun: 'obtenerCodigoPais' })
            dispatch('getProvincias', { datoComun: 'obtenerProvincias' })
            dispatch('getTiposFamiliares', { datoComun: 'obtenerTiposFamiliares' })
            dispatch('getEstadoCivil', { datoComun: 'obtenerEstadoCivil', filtro: payload ? 1 : 0 })
            // dispatch('getItemsNivel')
        }
    }
});
